import request from '../request'

export function fetchList(params) {
    return request({
        url: '/Api/article/getBannerList',
        params
    })
}